import type { CSSProperties } from 'react';
import type { Role } from '@death-star/shared';

// Icons traced from Lucide (ISC license). Stroke-based, currentColor.
const PATH_EYE = 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z';
const PATH_SHIELD = 'M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6l8-4z M9 12l2 2 4-4';
const PATH_CROWN = 'M3 7l4 4 5-6 5 6 4-4-2 11H5L3 7z';

interface BadgeInfo { color: string; path: string; label: Role; }

export function renderRoleBadge(role: Role | null): BadgeInfo | null {
  if (role === null) return null;
  if (role === 'viewer') return { color: 'var(--loop-neutral-700)', path: PATH_EYE, label: 'viewer' };
  if (role === 'triager') return { color: 'var(--loop-blue-700)', path: PATH_SHIELD, label: 'triager' };
  return { color: 'var(--loop-red-700)', path: PATH_CROWN, label: 'superAdmin' };
}

const wrap: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  height: 20,
  borderRadius: 'var(--loop-radius-sm)',
  padding: 2,
  marginRight: 'var(--loop-space-075)',
};

export function RoleBadge({ role }: { role: Role | null }) {
  const info = renderRoleBadge(role);
  if (info === null) return null;
  return (
    <span style={{ ...wrap, color: info.color }} title={`Role: ${info.label}`} aria-label={`Role: ${info.label}`}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={info.path} />
      </svg>
    </span>
  );
}
